import { render, staticRenderFns } from "./ListPurchaseOrderStatuses.vue?vue&type=template&id=4b169c52&scoped=true&"
import script from "./ListPurchaseOrderStatuses.vue?vue&type=script&lang=ts&"
export * from "./ListPurchaseOrderStatuses.vue?vue&type=script&lang=ts&"
import style0 from "./ListPurchaseOrderStatuses.vue?vue&type=style&index=0&id=4b169c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b169c52",
  null
  
)

export default component.exports